import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

export type DashboardV3 = {
  totalGroup: number;
  activeGroup: number;
  harvestedGroup: number;
  activeGroupPercent: number;
  harvestedGroupPercent: number;
  totalParticipatedArea: number;
  activeParticipatedArea: number;
  harvestedParticipatedArea: number;
  activeParticipatedAreaPercent: number;
  harvestedParticipatedAreaPercent: number;
  totalFarmer: number;
  activeFarmer: number;
  harvestedFarmer: number;
  activeFarmerPercent: number;
  harvestedFarmerPercent: number;
  expectedPipes: number;
  installedPipes: number;
  servicedPipes: number;
  secondServicedPipes: number;
  secondExpectedPipes: number;
};

type Params = {
  seasonId?: string;
  country?: string;
};

const useDashboardV3Query = (params: Params) => {
  const queryParams = useMemo(
    () => ({
      ...(params?.seasonId && { 'seasonTypeId.equals': params?.seasonId }),
      ...(params?.country && { 'country.equals': params?.country }),
    }),
    [params],
  );
  const query = useQuery<AxiosResponse<DashboardV3>>({
    queryKey: ['dashboard-v3', queryParams],
    queryFn: () => API.get('/dashboard/v3/summary', { params: queryParams }),
    enabled: !!params?.country && !!params?.seasonId,
  });

  return query;
};

export default useDashboardV3Query;
